
import i18nCommon from '@modules/i18n/mixins/Common';
import Vue, {VueConstructor} from 'vue';

export default (Vue as VueConstructor<Vue & InstanceType<typeof i18nCommon>>).extend({
  name: 'a-Label',
  mixins: [i18nCommon],
  props: {
    forId: {
      type: String,
      default: '',
    },
    optional: {
      type: Boolean,
      default: false,
    },
  },
});
